<template>
  <div class="detalhe">
    <i class="fa-solid fa-magnifying-glass"></i>
  </div>
</template>
<script>
export default {
  props: ['altura'],
  components: {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.detalhe {
  position: absolute;
  top: calc(50% - v-bind(altura));
  left: calc(50% - 20px);
  height: 60px;
  width: 60px;
  min-width: auto !important;
  color: white !important;
  -webkit-box-shadow: 0px 0px 42px 6px rgba(255, 255, 255, 0.9);
  -moz-box-shadow: 0px 0px 42px 6px rgba(255, 255, 255, 0.9);
  box-shadow: 0px 0px 42px 6px rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.3);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  //border: 1px solid white;
  cursor: pointer;
  i {
    margin-top: 25%;
    font-size: 30px;
    color: #fff !important;
  }
}
</style>
